import { render, staticRenderFns } from "./meta-watcher.vue?vue&type=template&id=7dcefe63"
import script from "./meta-watcher.vue?vue&type=script&lang=js"
export * from "./meta-watcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports